import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { message } from 'antd'

export default function ReadmissionQueryPass2() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const [configValue, setConfigValue] = useState({})

  useEffect(() => {
    document.title = '查询结果'

    axios.post('/c/retention_admission/config/get', { 
      merchant_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setConfigValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [oid])

  const handleDownload = (url) => {
    if (configValue.reporting_handbook_bachelor) {
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        navigator.clipboard.writeText(configValue.reporting_handbook_bachelor).then(() => {
          message.success('下载链接已复制，请在浏览器中打开查看或下载')
        }).catch(err => {
          console.error('复制失败: ', err)
        })
      } else {
        window.open(configValue.reporting_handbook_bachelor, '_blank')
      }
    } else {
      message.warning('模版文件不存在!')
    }
  }

  const handleReturn = () => {
    navigate('/readmission/query/login/' + oid)
  }

  return (
    <div className='result-page'>
      <div className='application-progress'>
        <div className='application-progress-number'>1</div>
        <div className='application-progress-name'>初审</div>
        <div className='application-progress-line'></div>
        <div className='application-progress-currentNumber'>2</div>
        <div className='application-progress-name'>复审</div>
      </div>

      <div className='result-icon'>
        <img src="/images/chenggong.png" alt="" />
      </div>
      <div className='result-title'>审核通过</div>
      <div className='result-description'>
        您的申请已通过审核，请自行下载并认真查看对应《新生报到手册》相关内容。
      </div>
      <div className='result-button-primary' onClick={() => handleDownload(configValue.reporting_handbook_bachelor)}>《新生报到手册（本科）》</div>
      <div className='result-button-primary' style={{marginTop: '20px'}} onClick={() => handleDownload(configValue.reporting_handbook_junior)}>《新生报到手册（专科）》</div>

      <div className='result-title2'>《专升本新生报到手册》</div>
      <div className='result-buttons-short'>
        <div className='result-button-short' onClick={() => handleDownload(configValue.reporting_handbook_3)}>金海校区</div>
        <div className='result-button-short' onClick={() => handleDownload(configValue.reporting_handbook_4)}>嘉善校区</div>
        <div className='result-button-short' onClick={() => handleDownload(configValue.reporting_handbook_5)}>长寿路校区</div>
      </div>
      <div className='result-button-secondary2' onClick={handleReturn}>返回</div>
    </div>
  )
}
